import Ripple from "../../../../../../dumb/Ripple";
import MerchantDropdown from "../../../../../../layouts/components/helpers/MerchantDropdown";
import React from "react";
import noop from "mn-utils/noop";
import upperFirst from "mn-utils/upperFirst";
import {tableFilters$} from "../../utils/tableFilters";
import {tableScroll$} from "../../utils/tableScroll";

import './styles.scss';

const ListItem = ({name, active, onClick = noop, index}) => {
  return (
    <Ripple
      className={
        `w h37 layoutRow jcSB aiC pl19 pr8 bxzBorderBox f12 c2 td bgFAFAFA.hasBg`
        + ((index + 1) % 2 !== 0 ? ' hasBg' : '')
      }
      onClick={onClick}
    >
      <span className="f12 fw7">{name}</span>
      <div className="w12 h12 rlv">
        <div className="w h abs st0 sl0 b1 bs bc73757A r50%" />
        <div className={
          `w8 h8 abs st2 sl2 bgTransparent bg0.active r50%`
          + (active ? ' active' : '')
        } />
      </div>
    </Ripple>
  )
}

const listMap = ({name, filtersData, onFiltersChange}) => (el, i) => (
  <ListItem
    key={i}
    index={i}
    name={el.name || upperFirst(el.id).split('_').join(' ')}
    active={filtersData[name]
      ? filtersData[name] === el.id
      : el.id === 'all'
    }
    onClick={() => {
      const nextFilters = {...filtersData};

      if (el.id === 'all') {
        delete nextFilters[name];
      } else {
        nextFilters[name] = el.id
      }

      onFiltersChange(nextFilters);
      tableFilters$.emit(nextFilters);
      tableScroll$.emit('');
    }}
  />
);

export default ({params, filtersData, onFiltersChange, label}) => {
  const mapFN = listMap({
    name: params.name,
    filtersData,
    onFiltersChange
  });

  const valueId = filtersData[params.name];
  const list = (params.list || []).length ? [{id: 'all'}, ...params.list] : [];
  const valueObj = list.find((el) => el.id === valueId);
  const valueDisplay = !valueObj
    ? ''
    : valueObj.headerNameDisplay
      ? valueObj.headerNameDisplay
      : upperFirst(valueId).split('_').join(' ');

  return (
    <MerchantDropdown
      id={`${params.name}TableHeadSelect`}
      className="header-filter"
      itemsList={list.map(mapFN)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      fullWidth
    >
      {valueDisplay
        ? (
          <div>
            {label}<br/>({valueDisplay})
          </div>
        ) : (
          label
        )}
    </MerchantDropdown>
  )
}
